// Dosespot sends prescription and medication state as integers. Both order
// screens (the Orders tab and the per-visit order view) have to turn those
// into words, so the maps live here rather than being copied into each.
const PRESCRIPTION_STATUS = {
  1: "Entered",
  2: "Printed",
  3: "Sending",
  4: "eRxSent",
  5: "FaxSent", // Deprecated
  6: "Error",
  7: "Deleted",
  8: "Requested",
  9: "Edited",
  10: "EpcsError",
  11: "EpcsSigned",
  12: "ReadyToSign",
  13: "PharmacyVerified",
};

const MEDICATION_STATUS = {
  0: "Unknown", // Deprecated
  1: "Active",
  2: "Inactive", // Deprecated
  3: "Discontinued",
  4: "Deleted",
  5: "Completed",
  6: "CancelRequested",
  7: "CancelPending",
  8: "Cancelled",
  9: "CancelDenied",
  10: "Changed",
  11: "FullFill",
  12: "PartialFill",
  13: "NoFill",
};

// Already-labelled values pass through: the per-visit endpoint maps these
// server-side, so a string here is the label, not a code.
const label = (map, status) => {
  if (typeof status === "string" && status.trim() !== "") return status;
  return map[status] ?? null;
};

export const getPrescriptionStatus = (status) => label(PRESCRIPTION_STATUS, status);
export const getMedicationStatus = (status) => label(MEDICATION_STATUS, status);
